import { getAppVersionNum } from '../../application/helper/appUtils';
import {
  TBridgeMap,
  IVersionDic,
  OS,
  withErrorHandler,
  createVersionChecker,
  os,
} from './index';

const iosVersionDic: IVersionDic = {
  openWebPage: [{ version: '00.00.00' }],
  close: [{ version: '00.00.00' }],
  goTauthHome: [{ version: '00.00.00' }],
  goNativeTab: [{ version: '00.00.00' }],
};
const aosVersionDic: IVersionDic = {
  openWebPage: [{ version: '00.00.00' }],
  close: [{ version: '00.00.00' }],
  goTauthHome: [{ version: '00.00.00' }],
  goNativeTab: [{ version: '00.00.00' }],
};

const createBridgeSkt = (os: OS) => {
  const iosRequest = (method: any, args: any) => {
    console.log('skt ios', method, args);

    if (method === 'goTauthHome') {
      // @ts-ignore
      window.location = 'jscall://goTauthHome';
    } else {
      if (method === 'openWebPage' || method === 'goNativeTab') {
        window.webkit?.messageHandlers?.tauthJs?.postMessage({
          method,
          args,
        });
      } else {
        window.webkit?.messageHandlers?.tauthJs?.postMessage({
          method,
        });
      }
    }
  };

  const aosRequest = (method: any, args: any) => {
    console.log('skt aos', method, args);
    if (method === 'openWebPage' || method === 'goNativeTab') {
      window?.tauthJs[method](JSON.stringify(args));
    } else {
      window?.tauthJs[method]();
    }
  };

  const bridge = (request: any) => {
    return {
      openWebPage: (option: any) => request('openWebPage', option),
      close: () => request('close'),
      goTauthHome: () => request('goTauthHome'),
      goNativeTab: ({ tabCode, linkUrl }: any) =>
        request('goNativeTab', { tabCode, linkUrl }),
    };
  };

  const request = os === OS.IOS ? iosRequest : aosRequest;

  return bridge(request);
};

const bridgeSktMap: TBridgeMap = (bridgeSkt, errorHandler, versionChecker) => {
  return {
    getParamInfo: (params) => {
      const {
        ctn,
        mgnt_cd,
        os_type,
        src_cd,
        track_cd,
        pass_money,
        queue_seq,
        challengeSeq,
        hideHeader,
        satelliteCustSeq,
      } = params;
      return {
        ctn: ctn,
        mgntCd: mgnt_cd,
        osType: os_type,
        srcCd: src_cd ?? '',
        trackCd: track_cd ?? '',
        queueSeq: queue_seq ?? '',
        pass_money: pass_money,
        challengeSeq: challengeSeq,
        hideHeader: hideHeader,
        satelliteCustSeq,
        version: (() => {
          const groups = navigator.userAgent.match(/;PASS\/([0-9\.]+)/);
          return groups && groups.length > 1 ? groups[1] : '99.99.99';
        })(),
      };
    },
    getAppVersion: () => {
      const groups = navigator.userAgent.match(/;PASS\/([0-9\.]+)/);
      return {
        version: groups && groups.length > 1 ? groups[1] : '99.99.99',
      };
    },
    openNativeWebView: ({ url, title, closeType }: any) => {
      withErrorHandler(
        () =>
          bridgeSkt.openWebPage({
            type: 'I',
            url,
            useHistoryBack: 'Y',
            headerObj: { title, closeType },
          }),
        versionChecker.openWebPage(),
        errorHandler,
      );
    },
    close: () => {
      withErrorHandler(
        () => bridgeSkt.close(),
        versionChecker.close(),
        errorHandler,
      );
    },
    openExternalBrowser: ({ url = '' }) => {
      withErrorHandler(
        () => bridgeSkt.openWebPage({ type: 'O', url }),
        versionChecker.openWebPage(),
        errorHandler,
      );
    },
    goNativeMain: () => {
      withErrorHandler(
        () => bridgeSkt.goTauthHome(),
        versionChecker.goTauthHome(),
        errorHandler,
      );
    },
    // goNativeTab: ({ tabCode, url }: any) => {
    //   withErrorHandler(
    //     () =>
    //       bridgeSkt.goNativeTab({
    //         tabCode: tabCode,
    //         linkUrl: url,
    //       }),
    //     versionChecker.goNativeTab(),
    //     errorHandler,
    //   );
    // },
    requestAddService: ({ type, url }) => {
      if (type === 'EBMP') {
        const appVersionNum = getAppVersionNum('skt');
        const isOldVersion = appVersionNum < 300130009; // 3.13.9

        withErrorHandler(
          () =>
            isOldVersion
              ? bridgeSkt.goNativeTab({
                  tabCode: 'TAB02',
                  linkUrl: `${url}&tabCode=TAB02`,
                })
              : bridgeSkt.openWebPage({
                  type: 'I',
                  url,
                  useHistoryBack: 'N',
                  isShowGNB: 'Y',
                  isSkipAuthAlert: 'N',
                }),
          isOldVersion
            ? versionChecker.goNativeTab()
            : versionChecker.openWebPage(),
          errorHandler,
        );
      }
    },
  };
};

export default (appVersion: string, errorHandler: () => void) => {
  const checker = createVersionChecker(
    appVersion,
    os === OS.IOS ? iosVersionDic : aosVersionDic,
  );
  const bridge = createBridgeSkt(os);

  return bridgeSktMap(bridge, errorHandler, checker);
};
